import { createSlice } from '@reduxjs/toolkit';
import { INITIAL_GEOFENCE_STATE } from './geofenceSlice.constants';
import { GEOFENCE_REDUCERS } from './geofenceSlice.reducers';

const {
  reducerSetGeofenceShapeType,
  reducerSetGeofenceDrawingMode,
  reducerSetCurrentGeofenceShapeData,
  reducerClearGeofenceDrawing,
  reducerSetShapeCenter,
  reducerSetShapeRadius,
  reducerSetSelectedGeofence,
  reducerSetHoveredGeofence,
  reducerSetGeofenceListParams,
  reducerSetGeofenceListData,
  reducerResetGeofenceList,
  reducerUpdateGeofenceSearchCriteria,
  reducerSetEditableRuleId,
  reducerSetDeletingRuleId,
} = GEOFENCE_REDUCERS;

export const geofenceSlice = createSlice({
  name: 'geofence',
  initialState: INITIAL_GEOFENCE_STATE,
  reducers: {
    setGeofenceShapeType: reducerSetGeofenceShapeType,
    setGeofenceDrawingMode: reducerSetGeofenceDrawingMode,
    setCurrentGeofenceShapeData: reducerSetCurrentGeofenceShapeData,
    clearGeofenceDrawing: reducerClearGeofenceDrawing,
    setShapeCenter: reducerSetShapeCenter,
    setShapeRadius: reducerSetShapeRadius,
    setSelectedGeofence: reducerSetSelectedGeofence,
    setHoveredGeofence: reducerSetHoveredGeofence,
    setGeofenceListParams: reducerSetGeofenceListParams,
    setGeofenceListData: reducerSetGeofenceListData,
    resetGeofenceList: reducerResetGeofenceList,
    updateGeofenceSearchCriteria: reducerUpdateGeofenceSearchCriteria,
    setEditableRuleId: reducerSetEditableRuleId,
    setDeletingRuleId: reducerSetDeletingRuleId,
  },
});

export const {
  setGeofenceShapeType,
  setGeofenceDrawingMode,
  setCurrentGeofenceShapeData,
  clearGeofenceDrawing,
  setShapeCenter: setTargetShapeCenter,
  setShapeRadius,
  setSelectedGeofence,
  setHoveredGeofence,
  setGeofenceListParams,
  setGeofenceListData,
  resetGeofenceList,
  updateGeofenceSearchCriteria,
  setEditableRuleId,
  setDeletingRuleId,
} = geofenceSlice.actions;

export const geofenceReducer = geofenceSlice.reducer;
